
export const DEFINICIONESIF_LOADED = 'DEFINICIONESIF_LOADED';
export const DEFINICIONIF_CHANGED = 'DEFINICIONIF_CHANGED';

export const definicionesifLoaded = (newDefinicionesif) => {
 return {
        type: DEFINICIONESIF_LOADED,
        definicionesif: newDefinicionesif,
    }
}

export const definicionifChanged = (ifid, newDefinicionif) => {
    return {
        type: DEFINICIONIF_CHANGED,
        definicionif: newDefinicionif,
        ifid: ifid,
    }
}
